import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRocket, faUsers, faLightbulb } from '@fortawesome/free-solid-svg-icons';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { CardHome } from './styles';

function HomePage(){
    return (
        <Container className="mt-5">
            <header className="text-center mb-5">
                <h2 className="display-4">Bem-vindo ao Tools System</h2>
                <p className="lead">Sua Plataforma Empresarial Integrada</p>
            </header>

            <Row className="mb-5">
                <Col md={4} className="text-center">
                    <CardHome>
                        <Card.Body>
                            <FontAwesomeIcon icon={faRocket} size="4x" className="text-primary mb-3" />
                            <Card.Title>Eficiência</Card.Title>
                            <Card.Text>
                            Maximize a eficiência em cada etapa da operação.
                            </Card.Text>
                        </Card.Body>
                    </CardHome>
                </Col>
                <Col md={4} className="text-center">
                    <CardHome>
                        <Card.Body>
                            <FontAwesomeIcon icon={faUsers} size="4x" className="text-success mb-3" />
                            <Card.Title>Colaboração</Card.Title>
                            <Card.Text>
                            Colabore de maneira eficiente em tempo real.
                            </Card.Text>
                        </Card.Body>
                    </CardHome>
                </Col>
                <Col md={4} className="text-center">
                    <CardHome>
                        <Card.Body>
                            <FontAwesomeIcon icon={faLightbulb} size="4x" className="text-info mb-3" />
                            <Card.Title>Inovação</Card.Title>
                            <Card.Text>
                            Explore novas possibilidades para o seu negócio.
                            </Card.Text>
                        </Card.Body>
                    </CardHome>
                </Col>
            </Row>

            <Row className="mb-5">
                <Col md={12} className="text-center">
                    <p className="lead">
                    É com grande entusiasmo que apresentamos o Tools System, o epicentro inovador de todas as operações do backoffice. Proporcionamos uma fusão harmoniosa de eficiência, controle e inteligência estratégica para cada departamento.
                    </p>
                </Col>
            </Row>

            <Row className="mb-5">
                <Col md={12} className="text-center">
                    <p className="lead">
                    Estamos comprometidos com a excelência em tecnologia e gestão, e estamos empolgados em ter você como parte integrante do Tools System. Juntos, estamos prontos para impulsionar o sucesso inigualável da empresa NPE. Para questões ou suporte, nossa equipe altamente capacitada está à disposição.
                    </p>
                </Col>
            </Row>

            <footer className="text-center mt-5">
                <p className="lead">Cordialmente, A Equipe de Tecnologia da Informação</p>
            </footer>
        </Container>
    );
};

export default HomePage;
